import { VisuallyHidden } from '@radix-ui/react-visually-hidden';
import { ComponentProps } from 'react';
import { Drawer, DrawerClose, DrawerContent, DrawerTitle } from '../../../../../design-system/drawer/drawer';
import { EditEmployeeDetailsDrawerContent } from './edit-employee-details-drawer-content';

type EditEmployeeDetailsDrawerProps = {
  isOpen: boolean;
  employeeDetailsConfig: ComponentProps<typeof EditEmployeeDetailsDrawerContent>['employeeDetailsConfig'];
  bankAccountDetailsConfig: ComponentProps<typeof EditEmployeeDetailsDrawerContent>['bankAccountDetailsConfig'];
  onClose: () => void;
};

export const EditEmployeeDetailsDrawer = ({
  isOpen,
  employeeDetailsConfig,
  bankAccountDetailsConfig,
  onClose,
}: EditEmployeeDetailsDrawerProps) => {
  return (
    <Drawer open={isOpen} onOpenChange={onClose} direction="right" modal={false}>
      <DrawerContent aria-describedby={undefined}>
        <VisuallyHidden>
          <DrawerTitle>Edit Employee Drawer</DrawerTitle>
        </VisuallyHidden>

        <DrawerClose aria-label="Close Drawer" className="right-6 top-6" onClick={onClose} />

        <EditEmployeeDetailsDrawerContent
          employeeDetailsConfig={employeeDetailsConfig}
          bankAccountDetailsConfig={bankAccountDetailsConfig}
        />
      </DrawerContent>
    </Drawer>
  );
};
